import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';


import Modal from '@vromo/ui/components/Modal';
import { useStore } from '@vromo/mobx-react/mobx-react';
import { RootStore } from 'dashboard/src/stores/RootStore';
import FontAwesome from '@vromo/ui/components/FontAwesome';
import { useAccount } from '../helpers';

export default observer(function Integrations({ children }) {


    const [open, setOpen] = useState(false);
    const { createIntegrationToken, oAuthToken } = useAccount()
    const { authStore: { role } } = useStore<RootStore>("rootStore")

    return (
        <>
            <Modal contentLabel="Integrations" isOpen={open} onRequestClose={() => setOpen(false)}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: 8
                    }}>
                    <h2 style={{ margin: 0 }}>Integrations</h2>
                    <div>
                        <a
                            href="https://docs.vromo.io"
                            target="_blank"
                            rel="noreferrer"
                            style={{ margin: '0 4px' }}>
                            API docs
                        </a>
                        <a
                            href="https://help.vromo.io/knowledge/integrate-with-vromo-through-zapier"
                            target="_blank"
                            rel="noreferrer"
                            style={{ margin: '0 4px' }}>
                            Zapier
                        </a>
                    </div>
                </div>

                {oAuthToken ?
                    <>
                        <label style={{ display: 'block' }}>API token</label>
                        <div
                            style={{
                                display: 'block',
                                fontFamily: 'monospace',
                                wordBreak: 'break-all',
                                maxWidth: 500
                            }}>
                            {oAuthToken}
                        </div>
                        <hr />
                    </> :
                    <div style={{ textAlign: 'center' }}>
                        <FontAwesome icon="spinner" spin large x3 />
                    </div>
                }
            </Modal>

            <span
                onClick={() => {
                    setOpen(true);
                    !oAuthToken && createIntegrationToken(role.id!);
                }}>
                {children}
            </span>
        </>
    );
});
